import AccountProviderInterface from './accountProviderInterface';
import { type AccountInfo } from '@/composables/accounts/providers/types';
import { DEFAULT_APPROVAL_AMOUNT_STRING } from '@/common/config';

export const PLAY_ACCOUNT_ID = 'play:account';
export const PLAY_ACCOUNT_ADDRESS = 'play_account';

class PlayAccountProvider extends AccountProviderInterface {
  async init(): Promise<void> {
    // Initialization logic for Play account provider
    return;
  }

  async connect(): Promise<void> {
    // Implementation for connecting to the Play account provider
  }

  async disconnect(): Promise<void> {
    // Implementation for disconnecting from the Play account provider
  }

  async ensureCorrectNetwork(): Promise<void> {
    // Play account doesn't interact with real networks - no-op
    return;
  }

  async getAccountBalance(): Promise<string> {
    // Mock implementation for getting account balance. 10K in Play Tokens
    return DEFAULT_APPROVAL_AMOUNT_STRING;
  }

  async getAccountInfo(accountId: string): Promise<AccountInfo> {
    // Mock implementation for getting account info
    return {
      id: accountId,
      address: PLAY_ACCOUNT_ADDRESS,
      name: 'Play Account',
    };
  }
}

export default PlayAccountProvider;
